import src from "IMAGE";
export default { src, width: 31, height: 35, blurWidth: 0, blurHeight: 0};
